import React, { useState } from 'react';
import { Save, ChevronDown } from 'lucide-react';
import { Lead, LeadState } from '../../types/lead';
import { IcpBadge, Badge, ScoreBadge } from '../ui/Badge';
import { EvidenceChecklist } from '../ui/EvidenceChecklist';
interface LeadHeaderProps {
  lead: Lead;
  onStateChange: (newState: LeadState) => void;
}
export function LeadHeader({
  lead,
  onStateChange
}: LeadHeaderProps) {
  const [showChecklist, setShowChecklist] = useState(false);
  const [pendingState, setPendingState] = useState<LeadState | null>(null);
  const states: LeadState[] = ['Nuevo', 'Contactado', 'Conversación', 'Micro-acuerdo', 'EnviadoPropuesta', 'LeadCualificado', 'Onboarding', 'Entregado', 'Rechazado', 'Nutrición_T+30'];
  const handleStateSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newState = e.target.value as LeadState;
    if (newState === 'LeadCualificado') {
      setPendingState(newState);
      setShowChecklist(true);
    } else {
      onStateChange(newState);
    }
  };
  const handleConfirmCualificado = () => {
    if (pendingState) {
      onStateChange(pendingState);
    }
    setShowChecklist(false);
    setPendingState(null);
  };
  return <>
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-6" data-id="element-394">
        <div className="flex items-start space-x-4" data-id="element-395">
          <ScoreBadge score={lead.LEAD_SCORE} priority={lead.ICP_PRIORITY} className="mt-1" data-id="element-396" />
          <div data-id="element-397">
            <div className="flex items-center space-x-3 mb-2" data-id="element-398">
              <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-399">
                {lead.NOMBRE_NEGOCIO}
              </h1>
              <IcpBadge priority={lead.ICP_PRIORITY} data-id="element-400" />
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-401">
              <Badge variant="outline" data-id="element-402">{lead.LEAD_SOURCE}</Badge>
              <Badge variant="outline" data-id="element-403">{lead.TAG_GEO}</Badge>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-3" data-id="element-404">
          <div className="relative" data-id="element-405">
            <select value={lead.STATE} onChange={handleStateSelect} className="appearance-none bg-growthly-surface border border-white/10 text-growthly-text text-[13px] font-medium rounded-md pl-4 pr-10 py-2 focus:outline-none focus:ring-2 focus:ring-growthly-amber" data-id="element-406">
              {states.map(s => <option key={s} value={s} data-id="element-407">
                  {s}
                </option>)}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-growthly-muted pointer-events-none" data-id="element-408" />
          </div>

          <button className="btn-primary inline-flex items-center" data-id="element-409">
            <Save className="w-4 h-4 mr-2" data-id="element-410" />
            Guardar{' '}
            <span className="ml-2 text-growthly-bg/70 text-[10px] border border-growthly-bg/30 rounded px-1 hidden sm:inline-block" data-id="element-411">
              S
            </span>
          </button>
        </div>
      </div>

      {showChecklist && <EvidenceChecklist lead={lead} onClose={() => {
      setShowChecklist(false);
      setPendingState(null);
    }} onConfirm={handleConfirmCualificado} data-id="element-412" />}
    </>;
}